import { cn } from '@/utils/cn';
import { GocoreLogoIcon } from '../icons/GocoreLogoIcon';

interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps) => {
  return (
    <GocoreLogoIcon
      className={cn(className, 'h-12 w-28 md:h-16 md:w-32')}
      desc="GoCore company logo"
      title="GoCore Logo"
    />
  );
};
